/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { Client } from 'fierry/flux';

import ShapeEnum, { getShapeToCount } from 'shared/enum/shape';

import Galaxy from 'shared/query/galaxy';
import Navigation from 'shared/client/navigation';

import * as Coords from 'shared/geo/coords';


export default new Client([ Navigation, Galaxy ], class
{
  constructor (navigation, galaxy)
  {
    this.galaxy = galaxy;
    this.navigation = navigation;

    this.source = navigation.getCurrent();
    this.target = navigation.getRawTarget();
  }


  onDone ()
  {
    const shape = this.navigation.getBehaviorShape();

    this.galaxy.attackUnit(this.source, this.target, shape);
  }


  getError ()
  {
    if (this.source.equals(this.target))
    {
      return 'Unit cannot attack zone it occupies.';
    }

    const distance  = Coords.getDistance(this.source.getCoords(), this.target.getCoords());

    if (distance < this.getUnitConstants().getTargetMinRange())
    {
      return 'Target zone is too close. Please select more distant target.';
    }

    if (distance > this.getUnitConstants().getTargetMaxRange())
    {
      return 'Target zone is out of range. Please select a closer target.';
    }

    if (!this.target.getZone())
    {
      return 'Cannot attack empty space.';
    }

    return null;
  }


  getInitial ()
  {
    if (this.target == null)
    {
      return 'Select target zone';
    }

    return null;
  }


  getUnitConstants ()
  {
    const unit = this.source.getZone().getUnit();

    return this.galaxy.getConstants().getUnit(unit.getType());
  }


});
